import {
  INICIALITZAR,
  VISUALITZACIO_OBTENIR_OBSERVACIONS
} from "../../actions/actionTypes";

const ESTAT_INICIAL = [];

const valors = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${VISUALITZACIO_OBTENIR_OBSERVACIONS}_SUCCESS`:
      return action.payload;

    case `${VISUALITZACIO_OBTENIR_OBSERVACIONS}_ERROR`:
      return action.error;

    default:
      return state;
  }
};

export default valors;

export const getVisibilitatObservacions = state => state.observacions;

const esArrayConDatos = obj => {
  return obj && Array.isArray(obj) && obj.length > 0;
};

export const getVisibilitatObservacionsByCamp = (state, camp) => {
  const sortByKey = key => (a, b) => (a[key] > b[key] ? 1 : -1);
  const sorted = esArrayConDatos(state.observacions)
    ? state.observacions.slice().sort(sortByKey(camp))
    : [];
  return sorted;
};
